interface SideMenuState {
    selectedMenuPoint:string, 
    isDropdownOpen:boolean,
    collapsed:boolean
    role:number,
}

export const SideMenuStateInitialState:SideMenuState={
    selectedMenuPoint:"a",
    isDropdownOpen:false,
    collapsed:false,
    role:0
}

export function deepCopySideMenuState(toCopy:SideMenuState) : SideMenuState {
    return {
        selectedMenuPoint:toCopy.selectedMenuPoint, 
        isDropdownOpen:toCopy.isDropdownOpen,
        collapsed:toCopy.collapsed,
        role:toCopy.role,
    }
}